import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
        
      <p class="mb-3">
        Hispanio… La lando de fieraj toreadoroj, ardaj belulinoj en mantiloj kaj migrantaj kavaliroj. 
        En pli moderna varianto – palmoj, Kanariaj insuloj kaj denove palmoj. “Ĉipa ripozo en plejbonaj ripozlokoj” por turistoj.
      </p>
        
      <p class="mb-3">
        Sed ni ne estas turistoj. 
        Kaj kvankam en nia vojaĝo ni vidis kaj toreadorojn, kaj belulinojn, kaj abundegis palmoj kaj plaĝoj – ne tio gravas! 
        La kerno estis la vojaĝo mem, kaj ĝia celo – Esperanta kongreso! 
        Tiu brila aventuro, kiu disvolviĝis en 5 landoj, restis la plej bela floro en bukedo de miaj rememoroj.
      </p>
        
      <p class="mb-5">
        Laŭvoje ni traveturis kvar landojn: Hungarion, Aŭstrion, Italion, Francion. 
        Kaj ĉie ni trovis plej varman akcepton en la domoj de tute nekonataj al ni homoj. 
        Jes, vi jam divenis: ni uzis “Pasportan Servon”! 
        En 1966 la ideon de tutmonda reto, kuniganta la gastemajn mastrojn, proponis juna argentina kuracisto Rubén Feldman González. 
        En 1974 aperis unua listo de gastigantoj kun 39 adresoj; kaj en 2024 da ili estas jam 2403 adresoj el 120 landoj. 
        Kaj same kiel neŭtrala kaj “artefarita” eŭro forigis multajn problemojn por vojaĝantoj inter diversaj landoj, 
        ankaŭ la lingvo Esperanto akompanis nin, kreante en ĉiuj sencoj la “verdan vojon”:-)
      </p>
      
      
      <p class="mb-5 bold text-center">* * *</p>
      
      
      <p class="mb-5">
        En Hungario ni veturis inter kampoj, vinberejoj kaj poste laŭ la bordo de la lago Balaton, kies akvo estis profunde lazura. 
        Sur alia flanko de la lago videblas griza vulkano Badacsony, sur kies deklivo kreskas vinberujo, 
        el kiu oni produktas la faman vinon “Griza amiko el Badacsony”. 
        La esperanta amiko Jozef disponigis al ni eĉ tutan malplenan loĝejon, kie ni bonege dormis surplanke en sagace kunprenitaj dormosakoj.
      </p>
      
      
      <p class="mb-5 bold text-center">* * *</p>
      
      
      <p class="mb-3">
        El Hungario ni direktis nin al Italio tra Aŭstrio. 
        Ĉar en mia regiono montoj tute forestas, ni iom timis tiun montaran parton de la vojo. 
        Sed vane! Komfortemaj eŭropanoj simple traboris la montojn per tuneloj, kaj la vojo ĉiam estis tute glata kaj ebena:-). 
        Trairinte dekon da tuneloj, ni komence supreniris al montaro, poste subiĝis – kaj jen ni en Italio! 
        Kaj denove deko da tuneloj; ni rimarkis, ke italaj tuneloj ne similas al la aŭstraj: alia formo, aliaj tegaĵoj; 
        kaj poste evidentiĝis, ke francaj tuneloj diferenciĝas de ambaŭ tiuj; sed la plej gravan, la montojn ni ne rimarkis! 
        Tro multe da submontaj pasejoj…
      </p>
      
      <p class="mb-3">
        En Italio ni gastis en mirinda urbo Padovo. 
        La placoj pavimitaj per marmoro, fontanoj, antikva Universitato… 
        Hela, pura impreso de la urbo, kvazaŭ de la taso el flava sonora porcelano; flava, kiel la domoj en Padovo.
      </p>
      
      <p class="mb-3">
        Nia mastro en Padovo estis olda fraŭlo, kiu tuj avertis nin, ke li ne manĝigas gastojn, kaj detale klarigis kion, 
        kie kaj kiel endas fari en lia domo. 
        Do, ni ĝuis trankvilon en absoluta ordo kaj pureco, ajnaj miskomprenoj ne eblis, kio estas tre oportune dum loĝado en fremdaj domoj, 
        ĉiu kun siaj kutimoj.
      </p>
      
      <p class="mb-3">
        Ankoraŭ dum la anticipa interkonsento nia estonta mastro ĝoje ekkriis: 
        “Kiel bone, vi povos ekvidi Venecion, ĝi troviĝas je duonhoro de ni!”. 
        Kaj nun li kompetente priskribis, kiel oni sin movu en Venecio, kie eblas nemultekoste manĝi ktp. 
        Kontraŭ 10 E tiam oni povis aĉeti tagan bileton por “akvaj tramoj” kaj la tutan tagon vojaĝi, ŝanĝante itinerojn. 
        Ni navigis laŭ Canal Grande kaj inter grandaj insuloj Giudecca, Lido, Murano, Burano ktp. 
        La tramo №82 faras ringan ĉirkaŭiron, kaj la ceteraj simple servas kiel lokaj trafikiloj. 
        Sekvante la utilan konsilon: “Ĵus vi laciĝis, tuj prenu ajnan trameton kaj navigu kien okuloj logas”, 
        ni dumtage vagadis tra Venecio kaj neniom laciĝis.
      </p>
      
      <p class="mb-3">
        Sed kiel ne laciĝi, se varmego tie fakte estas konstanta. 
        Ja en la urbo forestas eĉ spuroj de verdaĵoj, 
        kaj malvastaj ŝtonaj stratetoj ardiĝas pro alte staranta suno kaj transformiĝas en iujn ujojn por bakado, varmegaj de supre, 
        de malsupre kaj de flankoj. 
        Kaj ene moviĝas kaj bakiĝas homamaso; sur la centraj stratoj tumulto estas tiom densa, ke homoj sin frotas unu kontraŭ aliu. 
        Precipe tio okazas en Rialto; sed al mi ŝajnas, ke tiu amaso konsistas el turistoj, kaj venecianoj uzas promen- kaj ŝarĝboatojn, 
        en kiuj portas siajn aĉetaĵojn kaj ial ofte konstrumaterialojn. 
        En tiu jaro en duono de Venecio okazis foslaboroj, multaj kanaloj estis sekigitaj: oni renovigis kanalizacion. 
        Mia kunulo, inĝeniero pri tiu fako, ekinteresiĝis pri tiu procedo kaj konfirmis, ke la riparo okazas altnivele. 
        Kaj interalie, ni konvinkiĝis pri malvereco de onidiroj, ke en Venecio forestas kanalizacio kaj malpuraĵojn oni verŝas rekte al maro. 
        Fia mensogo: la akvo en kanaloj estas pura, verda kaj odoras je maro!
      </p>
      
      <p class="mb-5">
        Manĝis ni en fervojista manĝejo, kie abunda tagmanĝo kostis nur 5-7 E; la sumo ridinda por Venecio, 
        kiu vivas plejparte pro turistoj – sed ni ja ne estis turistoj! 
        Ni vojaĝis laŭ la reto de esperantistaj domoj kaj ĉie sentis sin kiel hejme!
      </p>
      
      
      <p class="mb-5 bold text-center">* * *</p>
      
      
      <p class="mb-3">
        La sekvan tagon ni venis al Francio. 
        Haltis en Nico, kie loĝis nia gastiganto – kuracisto kun akceptejo sur Promenade des Anglais. 
        Restis unu horo ĝis la fino de lia labortago, kaj ni decidis pasigi tiun horon surplaĝe. 
      </p>
      
      <p class="mb-3">
        Ho ve! Mi neniam vidis pli aĉan plaĝon ol tiu en Nico&#128532;. 
        Supre linio da palmoj, kaj post ili la seninterrompa vico da hoteloj kaj vendejoj. 
        Jes, apartaj domoj estas vere belaj; sed kuntiritaj je unu fadeno, ili deprimas per ia malvarma monotoneco. 
        Ĝenerale, la opinio de spertuloj pri Nico – “lerte reklamita urbo”. Ĝia gloro sin bazas sur reklamo kaj mono.
      </p>
      
      <p class="mb-3">
        Do, pri la plaĝo. 
        Ĝi estas kovrita per malgrandaj akraj ŝtonetoj, rezulto de disfalo de montaj mintavoloj sub ardanta suno. 
        Tio ne estas glataj kaj akve prilaboritaj rulŝtonetoj, kaj des pli ne sablo, kiel ĉe ni. 
        Sur tiuj ŝtonetoj estas dolore paŝi kaj dolore kuŝi, kaj anstataŭ plezuro la vizito al plaĝo fariĝas sufero. 
        Kompreneble, mi estas dorlotita de niaj veluraj plaĝoj; 
        sed tamen mi estas konvinkita, ke neniu krom joganoj ricevas plezuron de kuŝado sur akraj ŝtonoj&#128512;. 
        Ĉirkaŭe ne videblis revestejo aŭ necesejo, sed jes, sufiĉe multe da rubo. Kaj en la akvo flosis iuj pakaĵoj, paperoj… 
      </p>
      
      <p class="mb-5">
        Nur per nescio aŭ snobismo eblas klarigi emon RIPOZI en foraj landoj. 
        EKVIDI – jes! La strebo ekvidi novon kaj vojaĝi – unu el plej belaj homaj streboj. 
        Sed RIPOZI ja indas tie, kie pli agrablas ripozi! 
        Se homoj kapablus vidi tion, kio vere okazas, sed ne tion, kion oni sugestas al ili, 
        tiam niaj nigramaraj plaĝoj kun ilia ora sablo kaj karesanta korpon “silka” akvo, 
        kie forestas multaj venenaj, pikantaj kaj mordantaj animaloj, – do niaj plaĝoj fariĝus la plej multekostaj kaj homplenaj en la mondo! 
        Kaj kia feliĉo, ke dume ni povas uzi ilin senpage kaj sen konkurenco!
      </p>
      
      
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        Liberiĝis nia doktoro kaj kondukis nin al sia hejmo. 
        Li loĝas en montara vilaĝo je 30 km. de Nico. 
        Jen kie ni ekvidis la montaran vojon kaj montarajn pejzaĝojn! 
        Eĉ apud Nico restis impona viva naturo.
      </p>
        
      <p class="mb-3">
        La domo de l’ doktoro okazis plena malo de nia antaŭa loĝejo: kun 4 infanoj, la vivo bolas en ĝi. 
        “Infanoj! –, ekkriis la patro, rimarkinte, ke en la komputilo funkcias tute aliaj programoj kaj eĉ ne spuro restis de tiuj, 
        kiujn li instalis nur hieraŭ. – Infanoj, kiu tuŝis la komputilon?”. 
        Venis aro da infanoj, kaj evidentiĝis, ke tuŝis ĉiu, sed poiomete&#128512;. 
      </p>
        
      <p class="mb-3">
        Mi disdonis al ili la tutan provizon de suveniroj, kiujn portis por la Kongreso. 
        Poste mi montris al ili la filmon en Esperanto pri la naturo de Dnestro, kreitan en nia junulara esperanto-klubo “Verdaĵo”. 
        La infanoj ĝentile interrompis la spektadon de filmo kun S. Stallone&#128512;.
      </p>
      
      <p class="mb-5">
        Tre varman kaj vere familiecan vesperon pasigis ni en tiu familio. 
      </p>

      
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-5">
        Matene – antaŭen, en Hispanion! Ni planis ankoraŭ halti en Aix-en-Provence, Cannes, Saint-Tropez, Monte-Carlo, ludi ruleton… 
        Sed benzino kaj pagendaj vojoj devoris niajn financojn, kaj endis ŝpari kaj monon, kaj tempon. 
        Mi ne tro bedaŭras pri ŝikaj kurortoj (eblus la disreviĝo kiel de Nico); sed estis diable domaĝe preterveturi Camargue, 
        Arles, – tiujn rezervejojn de naturo kaj kulturo, pri kiuj ni tiel multe aŭdis kaj legis. 
        Apenaŭ ni trafos tien ankoraŭfoje, tiel akris deziro halti, kontempli… Sed pretere, pretere!
      </p>
      
      
      <p class="mb-5 bold text-center">* * *</p>
        
      
      <p class="mb-3">  
        Jen Hispanio. 
        Ni veturas al la urbo Reus, kie en vilao “Esperanto” atendas nin la lasta gastiganto, virino kun la nomo Luz, kio signifas Lumo. 
      </p>
      
      <p class="mb-3">
        Kaj jen fin-fine, post la fenestro – pejzaĝo tute ne simila al ĉio, kion ni vidis antaŭe. 
        Hispanio. Lando kun akre esprimita individueco. 
      </p>
      
      <p class="mb-3">
        Ni ne vidis flavajn sunbruligitajn ebenaĵojn de Kastilio, ĉar sekvante la bordojn de Mediteraneo, alvenis al la lando tra Pireneoj. 
        Post la fenestroj estis montoj, sed montoj strangaj, nekutimaj. 
        Ili similas al grandaj kestoj, al elefantoj, hipopotamoj… al io ajn, sed ne al kutimaj triangulaj elstaraĵoj. 
        Kaj iel strange ili lokiĝas por vido; ĉiam apud horizonto, sed neniam ŝirmas ĝin. Ŝajne, estas monto, kaj ŝajne ne…
      </p>
      
      <p class="mb-3">                                                        
        Luz venigis nin al sia vilao, kiu antaŭnelonge estis vera surnatura vilao. 
        Sed lastatempe en tiu distrikto komenciĝis amasa domkonstruado, kaj nun la domon ĉirkaŭas densa, preskaŭ urba kvartalo. 
        El naturo – nu, eble antaŭdoma ĝardeneto… 
        Poste, en Alicante ni vidis grafitiojn: “Ju pli multe da “verdaj zonoj”, des malpli multe da verdaĵo en urboj!”, 
        direktitajn kontraŭ tiaspeca kaŝita urbanigo, kiam ŝajne kreskas, sed reale estas neniigata verdaĵa abundo.
      </p>
        
      <p class="mb-3">
        Luz laboras kiel instruistino; ŝi, kiel mem diris, “disvolvas la cerbojn kaj trankviligas hormonojn” de 12-jaruloj. 
        Estas nefacila okupo en ajna lando. Nun, en ferioj, ŝi dediĉis al ni du tagojn, kiuj fariĝis, eble, 
        la plej brilaj kaj rememorindaj dum nia vojaĝo. 
        Ni trafis al la urbo Reus ĝuste en la tago de ĝia ĉiela patrono – St. Petro. 
        Vendrede paradis tra la urbo procesioj de gigantaj 3-metraj pupoj kun homoj ene: monstroj, reĝoj, maŭroj, ĉinoj… 
        Sed ni venis sabate, kaj sukcesis ekvidi nur la fajroartaĵon vespere. 
        Duonhoron turniĝis kaj eksplodis en ĉielo palmoj, radoj, bukedoj. 
        Kaj poste homoj venis al la urba placo, kie la urbestraro organizis koncerton por publiko. 
        Junularo iris al diskoteko en alia loko, sed tie ĉi kolektiĝis familioj: mezaĝuloj, maljunuloj, infanoj.
      </p>
        
      <p class="mb-3">
        En Hispanio oni ĝis nun observas sieston; kaj ĉar tage ili povas dormeti, do nokta vivo tie estas kutima afero. 
        Homoj ĉirkaŭ ni babilis, salutis konatajn, dancis: avoj kun nepinoj, panjoj kun filoj, gemaljunuloj kune. 
        Estis tia varma, natura, agrabla etoso! Ankaŭ ni sidis en “nia” familio kun Luz kaj ŝia edzo don Pedro, 
        babilis pri io ajn kaj sentis nin facile kaj ĝoje. 
        Jen, almenaŭ pro tiu senbara kaj senceremonia kuneco kun simplaj homoj, 
        pro eblo dividi ilian gajecon kaj partopreni iliajn festojn ne kiel turisto, – almenaŭ pro tio indas ekposedi Esperanton!
      </p>
        
      <p class="mb-3">
        Kaj sekvatage nin atendis io fantasta. Luz konstante diradis, ke morgaŭ okazos “homaj kasteloj”, sed mi ne povis kompreni, 
        kio estas tio. Kaj jen…
      </p>
        
      <p class="mb-3">
        Dimanĉe matene sur Magistrata placo, sub balkono de l’Urbodomo ni mem ekvidis tiujn “kastelojn”. 
        Kio estas tio? Ĉu sporto? Ĉu ludo? Estas antikva tradicio de Katalunio, simila al niaj sportaj “piramidoj” de 30-aj jaroj, 
        sed pli solida, kun multaj partoprenantoj kaj 5-7 “etaĝoj”. 
        La malsupraj sidis kaŭre laŭ la rondo, formante firman fundamenton; sur iliaj dorsoj staris kurbiĝinte “dua etaĝo”, 
        kaj ilin subtenis je ŝultroj, talioj kaj subgenue dekoj da homoj. 
        Se rigardi de supre (kaj ni spektis ĉion de l’ balkono de la Urbodomo, tiutage malfermita por ĉiuj), 
        tiam videblas nur monolita konuso formita de centoj da manoj, subtenantaj sportistojn (aŭ artistojn?). 
        Por partopreni tiujn “kastelojn”, oni sin trejnas tutan jaron, ja krom forteco kaj perfekta korpa ekvilibro, 
        necesas ankaŭ ideala kunlaboro de la tuta teamo, 
        endas laŭlitere senti la spiron kaj korbatadon de l’ partnero por teni ekvilibron starante sen ajna asekurado sur ŝultroj de kelkaj personoj, 
        dum sur viaj ŝultroj staras ankoraŭ kelkaj! 
        Ja homa korpo estas mola, elasta, ĝi ne povas ne oscili…
      </p>
        
      <p class="mb-3">
        La supraj “ludantoj” ĉirkaŭvolvas la talion per vasta skarpo kaj ankaŭ volvas specialajn ligojn sub genuoj; 
        kiam supren grimpas ludantoj de sekva etaĝo, ili sin kroĉas al tiuj ligoj kvazaŭ al ŝtupoj de ŝnura ŝtuparo. 
        Kompreneble, ĉiuj supraetaĝ-anoj grimpas nudpiede.
      </p>
        
      <p class="mb-3">
        Ni vidis konkurson de du teamoj: “oranĝa” kaj “viola”, inter partoprenantoj estis kaj fortaj viroj, kaj junulinoj, kaj infanoj. 
        Kiam tre alta piramido disfalas, la supraj teamanoj ne saltas suben: 
        ili sin levas al balkono de l’ Urbestraro laŭ malsuprenigita firma skarpo kun granda nodo. 
        Ni vidis, ke iu knabino, atinginte tiamaniere l’ balkonon, subite ekploregis. 
        Tiel esprimiĝis grandega nerva streĉo.
      </p>
        
      <p class="mb-3">
        En la urba parko de Tarragona mi vidis gisan monumenton: la “kastelon” el 5 etaĝoj. 
        Sed mi eĉ ne fotis ĝin: tio por povruloj, kiuj ne trafis al Reus aŭ Tarragona la 28-an de junio! 
        Ni ja vidis la vivajn 7-etaĝajn “kastelojn”!
      </p>
        
      <p class="mb-5">
        En Tarragona oni veturigis nin por montri romiajn antikvaĵojn. 
        Tie, pro ĝia seka modera klimato, estis ripozloko de romia nobelaro, kaj eĉ konserviĝis la domo, kie ripozis Pontio Pilato. 
        La legendo travivis jarcentojn, kaj ĝis nun tiun antikvan ŝtonbrikan domon oni nomas “la domo de Pilato”.
      </p>

      
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        Kaj jen ni estas en la urbo Alicante, la centro de provinco Alicante, kie okazas SAT-kongreso. 
        Nin oni loĝigis en universitata urbeto, praktike libera somere. 
        Ĝi similis al mi iun vizion de estonto: tri basenoj, kelkaj fontanoj, multaj monumentoj kaj abundego de verdaĵo: bosketoj, 
        florbedoj, aleoj de florantaj plantoj! 
        Ĉiuj vojoj en la sudaj landoj estis borderitaj de pompe florantaj oleandroj: blankaj, rozkoloraj, ruĝaj… 
        Unu el plej belaj miaj rememoroj de tiu tempo – senfinaj aleoj de oleandroj sub luna lumo…
      </p>
      
      <p class="mb-5">
        Interalie, post terura varmego en Suda Eŭropo ni atendis en Hispanio ion tute inferan. 
        Sed paradokse, tie konstante estis modere, foje eĉ ĝis 18°С! 
        Verŝajne, la Naturo kompatis nin por ke ni povu plene ĝui Hispanion:-) 
        Interese, ke siesto okazas en ajna vetero, sendepende de l’ temperaturo.
      </p>

      
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-5">
        La solena malfermo de la Kongreso okazis en la Kastelo de St. Barbara, kiu situas super la urbo, nokte estas bele prilumita, 
        kaj super ĝi flirtas ore-ruĝa hispana flago. 
        Dum la malfermo ĉeestis urba estraro, kaj poste ni estis invititaj al bankedo kun bonegaj hispanaj vinoj kaj paeljo. 
        Verdire, en la kastelo ĝi ekplaĉis al neniu; sed kian paeljon ni gustumis poste! 
        Tiam la mastroj aranĝis lignofajron surplaĝe, 
        tien oni alportis grandegan kaldronon kaj preparis paeljon por kelkcent personoj subĉiele. 
        Jen travivaĵo!
      </p>
        
      
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        Ĉiuj kongresoj de SAT sekvas certan programon. 
        Ĝi nepre inkluzivas du grandajn ekskursojn tra la lando, la duon- kaj plentagan. 
        Ĉar ciujare kongresoj okazas en diversaj landoj, ĉiu esperantisto estas ankaŭ vojaĝanto, 
        ekscianta pri kulturo kaj vivo de multaj lokoj. 
        “Via est vita”, “La vivo belas, ĉar en ĝi eblas vojaĝi” – jen belaj aforismoj, kiuj koncernas esperantistojn eĉ en dua potenco: 
        ja ili estas homoj, kiuj ekkonas vojagante kaj vojaĝas ekkonante, tiuj du aspektoj de vivo ĉe ili kunfluas.
      </p>
      
      <p class="mb-3">
        “La granda ekskurso” okazis en parto de orienta bordo de Hispanio, la urboj Canelobre, Guadalest kaj Benidorm. 
        Fakte, la unuaj du estas turistaj vilaĝoj, sed Benidorm jam estas urbo, evoluinta el fiŝista vilaĝeto dum lastaj kelkdek jaroj. 
        Ĝia nomo tradukeblas kiel “benita sonĝo”, kaj ĝi vere ŝajnas sonĝo, ne realo. 
        Mi unue ekvidis ĝin, kiam veturis el Reus al sudo. 
        Postfenestre kutima hispana pejzago: montoj, valoj, kasteloj sur pintoj de montoj, 
        vilaĝoj el blankaj dometoj sub ruĝaj tegmentoj en valoj… kaj jen, kvazaŭ en fabelo aŭ en sonĝo, 
        meze de tiu kvieta pratempa pejzaĝo aperas supermoderna urbo! 
        Sur ebenaĵo subite leviĝas al ĉielo nadloj de ĉielskrapantoj. 
        La domoj estas tre malvastaj, nur por unu enirejo, sed altaj pli ol 20 etaĝojn. 
        Tiu vizio preterflugas, malaperas, kaj poste denove etendiĝas ujutaj mediteraneaj urbetoj.
      </p>
      
      <p class="mb-3">
        Dum la ekskurso en Benidorm oni rakontis, ke tio estas vere modernega urbo, planita speciale por turistoj; 
        en ĝi forestas vidindaĵoj, sed abundas kafejoj, hoteloj ktp… 
        Famas ĝiaj plaĝoj: kiel ĉiam, sen revestejoj (ĉu vere “civilizita” lando?), sed senpagaj kaj kun mola dika sablo. 
        Tamen, neniu ĝuo sen sia malo: en la maro min brulvundis meduzo, kaj endis viziti dispensarion:-( 
          Kaj do, mi ankoraŭfoje ripetas: neniuj maroj kompareblas kun nia karesa Nigra maro, milda, varma kaj sendanĝera&#128512;. 
          Kiel bone, ke ne ĉiuj komprenas tion; aliel por ni ne restus loko surborde de tiu benita maro: ĉion okupus ja turistoj!:-)
      </p>
      
      <p class="mb-5">
        Sed jen ni mem kiel turistoj okupis la halon de restoracio en Benidorm. 
        Okazos bankedo omaĝe al organizanto de nia kongreso Martino Benito: li fariĝas 78-jara! Sed laŭ vigleco li superus eĉ 40-jarulojn&#128512;! 
        Reprezentantoj de diversaj landoj kantas por li nacilingve; responde li ekkantis “cante jondo” – profundan kantadon, 
        kiu esprimas la animon mem de hispana popolo. 
        Tio estis la VERA: ne por turistoj, sed por amikoj. 
        Tiel malfermiĝis antaŭ ni Hispanio.
      </p>

        
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        La urbeto Guadaleste laŭaspekte estas plena kontrasto al Benidorm. 
        Ĉi tie ĉio estas malnova, konservita, gardata… 
        Multas malgrandaj muzeetoj: ekz., tipa domo de hispano de 18a jc, kun ĉiuj objektoj de hejma mastrumado. 
        Aŭ “Muzeo de mikrogigantoj” – provu diveni, kion signifas tio! 
        Tre sprite: estas muzeo de miniaturaj kopioj de grandaj konstruaĵoj aŭ skulptaĵoj, kiuj videblas nur tra lupeo: ekz., 
        kopio de fama “Laokoono”, ĉizita el grifelo de ordinara krajono…
      </p>
      
      <p class="mb-5">
        Sed tromultas turistoj; la urbeto aspektas iom nenature kaj vivas ne por si mem.
      </p>
        
        
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        “Kanelobre” signifas en valensia dialekto “kandelabro”. 
        La urbeto nomiĝas tiel laŭ la nomo de fama groto, kie elkreskis giganta stalagmito simila al kandelabro. 
        Estas tie ankaŭ stalagmitoj en formo de meduzo, dormanta elefanto, drako, preĝanta madono… 
        La groto estas grandega, ĝis 700 metrojn profunden, kun ŝtuparoj strebantaj malsupren; akvofaloj, 
        ŝtoniĝintaj antaŭ milionjaroj; parietoj el mola flava ŝtono, per kiu pavimitaj ĉiuj stratoj en tiu regiono de Hispanio. 
        Ili estas malvarmetaj, humidaj kaj similas al haŭto de iu giganta lacerto, dormanta en la sino de la tero.
      </p>
      
      <p class="mb-3">
        Sed evidentiĝis, ke tiu groto estas ne tute natura: ĝi fariĝis ankaŭ per homaj manoj. 
        Dum la Civila milito en Hispanio oni produktis tie motorojn por aviadiloj batalantaj kontraŭ Franco. 
        Por krei tiel kolosan sekretan uzinon oni eksplodis subtere kelkajn grotojn, kuniginte ilin poste en unu areon. 
        Multaj stalagmitoj estis ekstermitaj; sed ne eblas ekstermi popolan reziston al faŝismo. 
        “La uzinoj de Kanelobre” funkciis ĝis la lasta horo, liverante aviadilojn por la bataloj.
      </p>
      
      <p class="mb-5">
        Interalie, Guernica, de kiu komenciĝis faŝista ofensivo al Hispanio, ankaŭ troviĝas en nord-oriento, en Katalunio. 
        Ĉi tie okazis grandaj bataloj; ĉi tie formiĝis la fama “Ejercito de Ebro”, 
        ankaŭ ĉi tie iam ekĝermis rekonkero de okupitaj de araboj hispanaj teritorioj: 
        Reconquista. Glora loko, fariĝinta nun turista paradizo!
      </p>

        
      <p class="mb-5 bold text-center">* * *</p>
        
        
      <p class="mb-3">
        Kaj jen, eble, la plej mirinda ekskurso; ekskurso el “Mil kaj unu noktoj” – al la urbo Elche, la Monda heredaĵo de UNESCO. 
        Fondita sur la loko de antikva kolonio Illicia, tiu malgranda urbeto estas neimageble pitoreska. 
        Ĉefa ĝia riĉaĵo estas palmoj. 
        Tie troviĝas 200 000 palmoj, unu okono de ĉiuj palmoj de Eŭropo. 
        Tiuj palmoj kontrastas de modestaj kaj magraj palmoj, kiujn ni vidis antaŭe, 
        same kiel bovo-reproduktanto de novnaskita bovido - hispana asocio de ideoj&#128512;! 
        La palmoj en Elche estas iaj ĝojaj: freŝaj, verdaj, brilantaj, plenaj de vivoforto. 
        Eble, ĉar ili multas? La soleca palmo ne donas ombron: ĝiaj folioj turniĝas rande al lumstrio por ne perdi akvon pro forvaporado. 
        Tamen en Elche palmoj tiel multas, ke iliaj folioj formas unu kontinuan verdan ŝirmon; 
        aŭ ia tremanta verda deltaplano ŝvebas super la urbo?
      </p>
        
      <p class="mb-3">
        En Elche troviĝas ankoraŭ unu Monda heredaĵo de UNESCO: la sola en la mondo Muzeo de Festo. 
        Tiu eksterordinara festo havas radikojn en Mezepoko; 
        en 1632 ĝi estis oficialigita de la papo Urbano VIII kaj ekde tiam okazas ĉiujare la 15an de aŭgusto, la tago de Ĉieliro de Maria. 
        Legendo diras, ke iam al Illicio albordiĝis boato kun statuo de St. Maria kaj manuskripto, kie detale estis priskribite, 
        kiel okazigi misterion pri Ĉieliro de Maria. 
      </p>
        
      <p class="mb-3">
        Kaj tutan tiun misterion, la solan en la mondo ĝisvivintan ĝis nun, ni vidis en Muzeo. 
        Virtuale. 
        Komence ni eniras la halon kun 6 ekranoj; ili ekfunkcias laŭvice, kaj ni vidas alvenon de la sankta boato al Illicio, 
        konstruadon de la templo omaĝe al la Ĉieliro kaj fine, la ceremonion mem. 
      </p>
        
      <p class="mb-3">
        En la plafono de la Baziliko de l’ Ĉieliro de Virgulino Maria malfermiĝas la luko kaj de tie malsupreniĝas giganta fermita ĉelo. 
        Subite ĝia tegaĵo krevas kaj ekflugas supren kvazaŭ flugiloj aŭ, pli ĝuste, kvazaŭ krono de palmo. 
        Ĝiaj folioj estas abunde kovritaj per kvadratetoj de ora staniolo, kiuj brilas kaj trembrilas en la lumo de lustroj. 
        Malsupre, sub tiu palmo en la pendanta ĉelo sidas knabino figuranta la Sanktan Marian. 
        La ĉelo malsupreniĝas ĝis la planko, la knabino kantas kun la ĥoro de “anĝeloj” kaj poste “mortas”, 
        kaj ŝin oni anstataŭigas per pupo, kiu ascendas supren. 
        Tie la pupon – la animon de la Dipatrino – forprenas la anĝelo kun palma branĉo. 
        Interese, ke la pupo havas brile nigran hararon: ja okazas tio en suda lando! Sed ni ja kutime imagas sanktulojn kun blonde oraj haroj…&#128512;
      </p>
        
      <p class="mb-3">
        Poste la ludo daŭras malsupre, inter la publiko. 
        Rabisto anoncas, ke li ne kredas je Ĉieliro de Maria kaj volas enrigardi en ŝian ĉerkon. 
        Kredantoj defendas la ĉerkon, komenciĝas interbatiĝo, tamen la Rabisto traŝiriĝas al la ĉerko, etendas al ĝi brakojn… 
        kaj lin frapas la fulmo! 
        De supre tiam descendas anĝelo, kiu kronas Marian kaj leviĝas kun ŝi en la kupolon de la templo. 
        Tiam de la krono de la “palmo” komencas faladi oraj petaloj, kovrante la preĝantaron per ora pluvo. 
      </p>
        
      <p class="mb-3">
        Mi vidis, mi vere vidis la tutan ceremonion! 
        Sed tio estis nur multekrana video kun multdimensia sono kaj eĉ imitado de aromoj. 
      </p>
        
      <p class="mb-3">
        En la dua halo de la muzeo – realaj objektoj: arfo, kiun ludis la “anĝelo” en la jaro 1812; 
        kostumoj de l’ partoprenintaj el diversaj epokoj, gitaroj k.a. rekvizito. 
        Sed post tio, kion mi vidis propraokule, realaj aĵoj en vitrino aspektas pli nenaturaj, nevivaj…   
      </p>
        
      <p class="mb-3">
        Ankoraŭ unu interesa muzeo en Elche – “Arabaj banejoj”. 
        Preskaŭ miljaron persistis tiuj ŝtonaj konstruaĵoj; ankoraŭ pasintjarcente en la ŝtonaj bankuvoj, 
        kie dolĉe langvoris iam arabaj konkerintoj kaj iliaj edzinoj, la entreprenemaj negociistoj tenis oleon, vinagron kaj vinon. 
        La banejoj mem iel similas al saŭnoj: la varmigita en ŝtonaj fornoj akvo trairis subteran tunelon, 
        varmigante la ŝtonojn de komuna halo, kaj poste sin verŝis en apartajn bankuvojn. 
        Estis tie ankaŭ malvarmaj basenoj. 
        Prilavo de la korpo antaŭ la preĝo estas grava parto de islama kulturo, 
        kaj troviĝo de banejoj en la urbo simbolis ĝian prosperon kaj altan ŝtupon de ekonomia disvolviĝo. 
      </p>
        
      <p class="mb-3">
        De antikva Elche restis por ni kultura heredaĵo – la fama Damo el Elche (IV-III jc. a.K.). 
        Tiu skulptaĵo de bela damo en stranga kapornamaĵo estas heredaĵo de iberoj, unuaj enloĝantoj de Hispanio. 
        Tamen kredu aŭ ne – sed la unua hispanino, renkontita de mi ankoraŭ survoje al Hispanio apud iu benzinejo, 
        estis vizaĝe tute simila al la Damo de Elche! 
        Jes, hispanoj vivas sur sia tero; ili enkreskis en ĝin per siaj radikoj, ensorbinte la kulturojn de ĉiuj antaŭaj popoloj: 
        iberoj, romianoj, keltoj kaj eĉ araboj kaj ciganoj. 
      </p>
        
      <p class="mb-3">
        Tiu bela suda tero ĉiam naskis homojn apartajn pro fiereco kaj sendependeco. 
        Siatempe, dum milito kontraŭ Napoleono nur en niaj du landoj la popoloj ne humiliĝis al konkerantoj, 
        sed organizis rezistadon – la partizanan militon. 
        Kaj ni kredas, ke tiu komuneco de popola spirito firmigos niajn rilatojn kaj spirite, kaj reale! 
      </p>
      
    </div>
    `
  )
}

const itemName = {
  esp: 'Neturista vojaĝo al Hispanio'
}


const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;